import { ReactNode } from 'react'
import { UserProvider } from '@contexts/user.context'
import { TemplatesProvider } from '@contexts/templates.context'
import { TagsProvider } from '@contexts/tags.context'
import { AuthProvider } from '@contexts/auth.context'
import { ConversationsProvider } from '@contexts/conversations.context'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

const CACHE_TIME = 5 * 60 * 1000 // 5 minutes
const GC_TIME = 10 * 60 * 1000 // 10 minutes

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: CACHE_TIME,
      gcTime: GC_TIME,
    },
  },
})

interface AppProviderProps {
  children: ReactNode
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <UserProvider>
          <ConversationsProvider>
            <TemplatesProvider>
              <TagsProvider>{children}</TagsProvider>
            </TemplatesProvider>
          </ConversationsProvider>
        </UserProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
